import { tourBackButton, tourCustomButton, tourExitButton, tourNextButton } from '../data/tour-buttons';
import { type TourStepDefinition } from '../data/tour-config';
import { TourService } from '../services/tour/tour.service';

export function getMedicationsTour(tourService: TourService): TourStepDefinition[] {
  return [
    {
      id: 'medicationsTourIntro',
      buttons: [tourExitButton(tourService, 'Skip Tour'), tourNextButton('Start Tour')],
      title: 'Welcome to Your Medications!',
      text: "Let's take a quick tour to help you understand your medication list.",
    },
    {
      id: 'medicationsTourFilterOptions',
      attachTo: {
        element: '#filterOptions',
        on: 'bottom',
      },
      scrollTo: false,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (1 of 3)')],
      title: 'Filter Options',
      text: () =>
        `<div class="flex flex-col gap-6">
      <span>Use the tabs to view different medication lists:</span> 
      <ul>
      <li><strong>Current Medications</strong> - Medications you are actively taking</li>
      <li><strong>Past Medications</strong> - Medications you are no longer taking</li>
      </ul>
      <span class="mt-5">Switch between tabs anytime to see the medications you need.</span> 
      </div>`,
    },
    {
      id: 'medicationsTourMedicationDetails',
      attachTo: {
        element: '#med-0',
        on: 'bottom',
      },
      scrollTo: false,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (2 of 3)')],
      title: 'Medication Details',
      text: () =>
        `<div class="flex flex-col gap-6">
      <span>Each medication shows:</span> 
      <ul>
      <li><strong>Medication name, strength, and form</strong> (like "aspirin 325 mg tablet")</li>
      <li><strong>Brand name</strong> in parentheses when applicable</li>
      <li><strong>Dosage instructions</strong> below (like "1 tab by mouth daily")</li>
      </ul>
      <span class="mt-5">
      Select the medication to see complete information including refills, prescriber, and pharmacy.
      </div>
      </span>`,
    },
    {
      id: 'medicationsTourUnderstandingStatus',
      attachTo: {
        element: '.status-text',
        on: 'bottom',
      },
      scrollTo: true,
      buttons: [tourBackButton('Back', ['two-row-btn']), tourNextButton('Done (3 of 3)')],
      title: 'Understanding Status',
      text: () =>
        `<div class="flex flex-col gap-10">
        <span>Medication statuses help you track your prescriptions:</span>
        <ul>
        <li><strong>No status shown</strong> = No active prescriptions</li>
        <li><strong>Refill</strong> = Prescription available for refill</li>
        <li><strong>Pending</strong> = Refill submitted to your provider awaiting their approval</li>
        </ul>
        <span>Tap on any medication to see full prescription information, request refills, or contact your provider with questions. Scroll down to see your complete medication list.</span> 
      </div>`,
    },
    {
      id: 'medicationsTourOutro',
      buttons: [tourCustomButton('Got it', 'primary', () => tourService.complete())],
      title: "You're All Set!",
      text: () =>
        `<div class="flex flex-col gap-6">
        <span><strong>You can access this tour again anytime from the medications screen.</strong></span>
      </div>`,
    },
  ];
}
